/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.10
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InternalAdminWhitelabelResponseV4FromJSON, InternalAdminWhitelabelResponseV4ToJSON, } from './InternalAdminWhitelabelResponseV4';
import { CommonResponseCollectionPaginationFromJSON, CommonResponseCollectionPaginationToJSON, } from './CommonResponseCollectionPagination';
/**
 * Check if a given object implements the InternalAdminWhitelabelResponseCollectionV4 interface.
 */
export function instanceOfInternalAdminWhitelabelResponseCollectionV4(value) {
    if (!('pagination' in value) || value['pagination'] === undefined)
        return false;
    if (!('data' in value) || value['data'] === undefined)
        return false;
    if (!('cloudflareIps' in value) || value['cloudflareIps'] === undefined)
        return false;
    return true;
}
export function InternalAdminWhitelabelResponseCollectionV4FromJSON(json) {
    return InternalAdminWhitelabelResponseCollectionV4FromJSONTyped(json, false);
}
export function InternalAdminWhitelabelResponseCollectionV4FromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'pagination': CommonResponseCollectionPaginationFromJSON(json['pagination']),
        'data': (json['data'].map(InternalAdminWhitelabelResponseV4FromJSON)),
        'cloudflareIps': json['cloudflare_ips'],
    };
}
export function InternalAdminWhitelabelResponseCollectionV4ToJSON(json) {
    return InternalAdminWhitelabelResponseCollectionV4ToJSONTyped(json, false);
}
export function InternalAdminWhitelabelResponseCollectionV4ToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'pagination': CommonResponseCollectionPaginationToJSON(value['pagination']),
        'data': (value['data'].map(InternalAdminWhitelabelResponseV4ToJSON)),
        'cloudflare_ips': value['cloudflareIps'],
    };
}
